require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/cart/minicart.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/cart/minicart.legacy.js
// module id = 640
// module chunks = 31